export default function LatestActivity() {
  return <div>TODO:LatestActivity</div>;
}
